var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-bar"},_vm._l((_vm.tags),function(tag,index){return _c('Tag',{key:index,staticClass:"post-tag",nativeOn:{"click":function($event){return _vm.handleTagSelect(tag)}}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }